<div *ngIf="isLobbyLoaded">
    <cc-new-game-quick-info *ngIf="isNewQuickInfoEnabled"></cc-new-game-quick-info>
    <cc-rp-fav-widget [lobbyType]="lobbyType" [gameContainer]="'Widget'"></cc-rp-fav-widget>
    <cc-rcp-fav-logout-widget [lobbyType]="lobbyType"></cc-rcp-fav-logout-widget>
</div>
